<template>
  <v-container>
    <v-layout row justify-center>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <div>下書きID：{{ draftId }}</div>

            <div v-if="!ice">
              <v-radio-group v-model="pageProgressionDirection">
                <v-layout> <label>読む方向</label> </v-layout>
                <v-layout row wrap>
                  <v-radio label="右から左へ" value="rtl"></v-radio>
                  <v-radio label="左から右へ" value="ltr"></v-radio>
                  <v-radio label="縦" value="vertical"></v-radio>
                </v-layout>
              </v-radio-group>

              <v-card class="pa-2 mb-2">
                <v-layout row wrap>
                  <v-card
                    v-for="(image, index) in images"
                    :key="index"
                    :width="150"
                    class="mr-3 mb-3"
                  >
                    <v-img
                      v-if="image.isBlank == false"
                      :src="image.imageUrl"
                      :width="128"
                      :height="182"
                      contain
                    >
                    </v-img>
                    <div v-else style="width:128px; height:182px; padding:10px">
                      空白画像
                    </div>

                    <v-card-text>
                      <div class="grey--text">#{{ image.imageId }}</div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        small
                        color="info"
                        @click.prevent="moveUpImage(image, index)"
                      >
                        <v-icon>fas fa-angle-up</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        small
                        color="info"
                        @click.prevent="moveDownImage(image, index)"
                      >
                        <v-icon>fas fa-angle-down</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        small
                        color="error"
                        @click.prevent="deleteImage(image, index)"
                      >
                        <v-icon>fas fa-minus</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-layout>

                <v-layout justify-end>
                  <v-dialog v-model="isShowSelectImageDialog">
                    <v-btn slot="activator" color="primary" icon large>
                      <v-icon>fas fa-plus</v-icon>
                    </v-btn>

                    <v-card>
                      <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                      >
                        画像追加
                      </v-card-title>

                      <v-card-text>
                        <v-layout justify-center>
                          <input
                            type="file"
                            ref="selectImage"
                            @change.prevent="selectImageFile"
                            style="display:none;"
                          />
                          <v-btn
                            color="primary"
                            right
                            @click.prevent="$refs.selectImage.click()"
                            :disabled="isImageUploadProcessing"
                          >
                            ファイルを選択
                          </v-btn>
                        </v-layout>
                        <v-layout justify-end>
                          <v-btn
                            @click.prevent="addBlankImage"
                            :disabled="isImageUploadProcessing"
                          >
                            空白ページ挿入
                          </v-btn>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          flat
                          @click="isShowSelectImageDialog = false"
                          >CLOSE</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-layout>
              </v-card>
              <v-layout justify-end>
                <v-btn
                  :loading="isPreviewLoading"
                  :disabled="isPreviewLoading"
                  @click="preview"
                >
                  プレビュー
                </v-btn>
                <v-progress-linear
                  class="ma-0"
                  v-if="isPreviewLoading"
                  v-model="previewProceedPercent"
                  :height="5"
                  color="blue lighten-3"
                ></v-progress-linear>
              </v-layout>
            </div>
            <v-layout row wrap>
              <v-flex>
                <v-layout column>
                  <label for="exampleInputFile">サムネイル画像</label>
                  <v-img
                    :src="computedThumbnailImageUrl"
                    v-if="computedThumbnailImageUrl"
                    :width="128"
                    :height="182"
                    contain
                  ></v-img>
                  <div v-else style="width: 128px;height:182px;"></div>
                </v-layout>
                <v-dialog v-model="isShowSelectThumbnailImageDialog">
                  <v-btn small color="primary" slot="activator">設定</v-btn>
                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                      サムネイル画像設定
                    </v-card-title>

                    <v-card-text>
                      <v-layout
                        v-if="!thumbnailImageOriginalFileData"
                        justify-center
                      >
                        <input
                          type="file"
                          ref="selectThumbnailImage"
                          @change.prevent="selectThumbnailImageFile"
                          style="display:none;"
                        />
                        <v-btn
                          color="primary"
                          right
                          @click.prevent="$refs.selectThumbnailImage.click()"
                        >
                          ファイルを選択
                        </v-btn>
                      </v-layout>
                      <div
                        v-else-if="
                          thumbnailImageOriginalFileData && showCropper
                        "
                      >
                        <vue-cropper
                          ref="thumbnailImageCropper"
                          :src="thumbnailImageOriginalFileData"
                          :view-mode="thumbnailImageCropperViewMode"
                          drag-mode="move"
                          :aspect-ratio="257 / 364"
                          :guides="false"
                          :auto-crop-area="1"
                          :background="false"
                          :img-style="{
                            'max-width': '100%',
                            'max-height': '300px'
                          }"
                          :crop-box-movable="false"
                          :crop-box-resizable="false"
                          :toggle-drag-mode-on-dblclick="false"
                          :modal="false"
                          :ready="selectThumbnailImageCropperReady"
                        ></vue-cropper>
                        <v-layout row wrap>
                          <v-btn
                            fab
                            small
                            color="primary"
                            @click="thumbnailImageCropperZoom(0.1)"
                            ><v-icon>fas fa-search-plus</v-icon></v-btn
                          >
                          <v-btn
                            fab
                            small
                            color="primary"
                            @click="thumbnailImageCropperZoom(-0.1)"
                            ><v-icon>fas fa-search-minus</v-icon></v-btn
                          >

                          <v-radio-group
                            row
                            v-model="thumbnailImageCropperViewMode"
                          >
                            <v-radio label="はみだしを許可する" :value="0" />
                            <v-radio label="はみだしを許可しない" :value="2" />
                          </v-radio-group>
                        </v-layout>
                        <v-layout justify-end>
                          <v-btn
                            color="primary"
                            @click.prevent="setThumbnailImage"
                            :disabled="isThumbnailImageUploadProcessing"
                            >設定</v-btn
                          >
                          <v-btn
                            color="default"
                            @click.prevent="
                              thumbnailImageOriginalFileData = null
                            "
                            :disabled="isThumbnailImageUploadProcessing"
                            >キャンセル</v-btn
                          >
                        </v-layout>
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        flat
                        @click="isShowSelectThumbnailImageDialog = false"
                        :disabled="isThumbnailImageUploadProcessing"
                        >CLOSE</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn
                  small
                  color="default"
                  :disabled="thumbnailImageUrl == null"
                  @click.prevent="resetThumbnailImage"
                  >リセット</v-btn
                >

                <vue-cropper
                  ref="defaultThumbnailImageCropper"
                  v-show="true"
                  :src="defaultThumbnailImageOriginalFileData"
                  :view-mode="2"
                  drag-mode="move"
                  :aspect-ratio="257 / 364"
                  :guides="false"
                  :auto-crop-area="1"
                  :background="false"
                  :img-style="{ 'max-width': '100%', 'max-height': '300px' }"
                  :toggle-drag-mode-on-dblclick="false"
                  :modal="false"
                  :check-cross-origin="false"
                  :ready="
                    () => {
                      selectThumbnailImageCropperReady(
                        this.$refs.defaultThumbnailImageCropper
                      );
                      this.selectDefaultThumbnailImagePromise = selectDefaultThumbnailImage();
                    }
                  "
                ></vue-cropper>
              </v-flex>
              <v-flex>
                <v-text-field v-model="title" label="タイトル" />
                <v-textarea v-model="description" label="概要"></v-textarea>
              </v-flex>
            </v-layout>

            <v-radio-group v-model="publicationType">
              <v-layout> <label>公開範囲を設定する</label> </v-layout>
              <v-layout row wrap>
                <v-radio label="誰でも閲覧可能" value="public"></v-radio>
                <v-radio label="合言葉が必要" value="secret_word"></v-radio>
              </v-layout>
            </v-radio-group>

            <v-text-field
              v-if="publicationType == 'secret_word'"
              label="合言葉"
              v-model="secretWord"
            ></v-text-field>

            <v-radio-group v-model="isCommentEnabled">
              <v-layout> <label>コメント投稿</label> </v-layout>
              <v-layout row wrap>
                <v-radio label="受け付ける" value="1"></v-radio>
                <v-radio label="受け付けない" value="0"></v-radio>
              </v-layout>
            </v-radio-group>
            <v-layout justify-center>
              <v-btn
                color="primary"
                large
                @click.prevent="publish"
                :disabled="isDraftPutting || isPublishing"
                :loading="isPublishing"
                >公開する</v-btn
              >
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import "vue-cropperjs";

export default {
  name: "vc-share-sample-contents-uploader",
  props: {
    ice: {
      type: Boolean,
      default: false
    },
    initialDraftId: {
      type: Number,
      default: null
    },
    initialTitle: {
      type: String,
      default: null
    },
    initialDefaultThumbnailImageUrl: {
      type: String,
      default: null
    },
    csrfToken: {
      type: String,
      default: ""
    },
    jwt: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      draftId: null,
      isDraftPutting: false,
      pageProgressionDirection: "",
      images: [],
      isShowSelectImageDialog: false,
      isImageUploadProcessing: false,
      thumbnailImageUrl: null,
      title: this.initialTitle,
      description: null,
      publicationType: null,
      secretWord: null,
      isCommentEnabled: null,
      imageFile: null,
      thumbnailImageOriginalFileData: "",
      thumbnailImageCropperRotation: 0,
      thumbnailImageCropperViewMode: 0,
      showCropper: true,
      thumbnailImageFile: null,
      isShowSelectThumbnailImageDialog: false,
      isThumbnailImageUploadProcessing: false,
      defaultThumbnailImageUrl: this.initialDefaultThumbnailImageUrl,
      defaultThumbnailImageOriginalFileData: null,
      selectDefaultThumbnailImagePromise: null,
      isPreviewLoading: false,
      previewTimeProceedSec: 0,
      previewEstimateProcessingTimeSec: 0,
      isPublishing: false
    };
  },
  computed: {
    computedThumbnailImageUrl: function() {
      if (this.thumbnailImageUrl) {
        return this.thumbnailImageUrl;
      } else if (this.defaultThumbnailImageUrl) {
        return this.defaultThumbnailImageUrl;
      } else {
        return null;
      }
    },
    previewProceedPercent() {
      // 推定進捗状況のため、最後を100%とせず、処理が完了していないことを表現する
      return (
        (this.previewTimeProceedSec / this.previewEstimateProcessingTimeSec) *
        95
      );
    }
  },
  mounted: function() {
    if (!this.ice) {
      fetch("/ja-jp/upload-contents/web-api/draft", {
        body: JSON.stringify({
          jwt: this.jwt
        }),
        headers: {
          "content-type": "application/json",
          "X-CSRF-TOKEN": this.csrfToken
        },
        method: "POST"
      })
        .then(response => response.json())
        .then(e => {
          if (e.status == 0) {
            this.draftId = e.data.draftId;
          }
        });
    } else {
      this.draftId = this.initialDraftId;
    }

    this.$watch(
      () => [
        this.pageProgressionDirection,
        this.title,
        this.description,
        this.publicationType,
        this.secretWord,
        this.isCommentEnabled
      ],
      () => {
        this.saveDraft();
      }
    );

    this.$watch(
      () => [this.thumbnailImageCropperViewMode],
      () => {
        this.showCropper = false;
        this.$nextTick(() => {
          this.showCropper = true;
        });
      }
    );
  },
  methods: {
    saveDraft: function() {
      this.isDraftPutting = true;
      fetch("/ja-jp/upload-contents/web-api/draft", {
        body: JSON.stringify({
          draftId: this.draftId,
          title: this.title,
          description: this.description,
          pageProgressionDirection: this.pageProgressionDirection,
          publicationType: this.publicationType,
          secretWord: this.secretWord,
          isCommentEnabled: this.isCommentEnabled
        }),
        headers: {
          "content-type": "application/json",
          "X-CSRF-TOKEN": this.csrfToken
        },
        method: "PUT"
      }).then(() => {
        this.isDraftPutting = false;
      });
    },
    selectImageFile: function(e) {
      var files = e.target.files;
      if (files.length > 0) {
        this.imageFile = files[0];

        this.addImage();
      }
    },
    addImage: function() {
      if (!this.imageFile) {
        return;
      }

      var thisObj = this;
      var newImageId = null;
      this.isImageUploadProcessing = true;
      fetch("/ja-jp/upload-contents/web-api/draft-images", {
        body: JSON.stringify({
          draftId: thisObj.draftId,
          isBlank: false
        }),
        headers: {
          "content-type": "application/json",
          "X-CSRF-TOKEN": thisObj.csrfToken
        },
        method: "POST"
      })
        .then(response => response.json())
        .then(e => {
          if (e.status == 0) {
            newImageId = e.data.imageId;
            return fetch(e.data.signedUrl, {
              body: thisObj.imageFile,
              method: "PUT"
            });
          }
        })
        .then(function() {
          return fetch("/ja-jp/upload-contents/web-api/draft-images-complete", {
            body: JSON.stringify({
              draftId: thisObj.draftId,
              imageId: newImageId
            }),
            headers: {
              "content-type": "application/json",
              "X-CSRF-TOKEN": thisObj.csrfToken
            },
            method: "POST"
          });
        })
        .then(response => response.json())
        .then(function(e) {
          if (e.status == 0) {
            thisObj.images.push({
              imageId: newImageId,
              imageUrl: e.data.imageUrl,
              filename: thisObj.imageFile.name,
              isBlank: false
            });
            thisObj.isShowSelectImageDialog = false;
            thisObj.isImageUploadProcessing = false;

            if (!thisObj.defaultThumbnailImageUrl) {
              thisObj.defaultThumbnailImageOriginalFileData = e.data.imageUrl;
              thisObj.$refs.defaultThumbnailImageCropper.replace(
                e.data.imageUrl
              );

              thisObj.selectDefaultThumbnailImagePromise.then(() => {
                //console.log('selectDefaultThumbnailImagePromise');
              });
            }
          }
        });
    },
    selectDefaultThumbnailImage() {
      return new Promise(resolve => {
        if (
          typeof this.$refs.defaultThumbnailImageCropper.getCroppedCanvas()
            .toBlob == "function"
        ) {
          this.$refs.defaultThumbnailImageCropper
            .getCroppedCanvas()
            .toBlob(blob => {
              resolve(blob);
            });
        } else {
          const binStr = atob(
            this.$refs.defaultThumbnailImageCropper
              .getCroppedCanvas()
              .toDataURL()
              .split(",")[1]
          );
          const len = binStr.length;
          const arr = new Uint8Array(len);

          for (let i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
          }

          resolve(new Blob([arr]));
        }
      }).then(blob => {
        fetch("/ja-jp/upload-contents/web-api/draft-thumbnail-image", {
          body: JSON.stringify({
            draftId: this.draftId,
            isDefault: true
          }),
          headers: {
            "content-type": "application/json",
            "X-CSRF-TOKEN": this.csrfToken
          },
          method: "POST"
        })
          .then(response => response.json())
          .then(e => {
            if (e.status == 0) {
              return fetch(e.data.signedUrl, {
                body: blob,
                method: "PUT"
              });
            }
          })
          .then(function() {
            return fetch(
              "/ja-jp/upload-contents/web-api/draft-thumbnail-image-complete",
              {
                body: JSON.stringify({
                  draftId: this.draftId,
                  isDefault: true
                }),
                headers: {
                  "content-type": "application/json",
                  "X-CSRF-TOKEN": this.csrfToken
                },
                method: "POST"
              }
            );
          })
          .then(response => response.json())
          .then(function(e) {
            if (e.status == 0) {
              this.defaultThumbnailImageUrl = e.data.imageUrl;
            }
          });
      });
    },
    addBlankImage: function() {
      var thisObj = this;
      this.isImageUploadProcessing = true;
      fetch("/ja-jp/upload-contents/web-api/draft-images", {
        body: JSON.stringify({
          draftId: thisObj.draftId,
          isBlank: true
        }),
        headers: {
          "content-type": "application/json",
          "X-CSRF-TOKEN": thisObj.csrfToken
        },
        method: "POST"
      })
        .then(response => response.json())
        .then(e => {
          if (e.status == 0) {
            thisObj.images.push({
              imageId: e.data.imageId,
              imageUrl: "",
              isBlank: true
            });
            this.isShowSelectImageDialog = false;
            this.isImageUploadProcessing = false;
          }
        });
    },
    deleteImage: function(image, index) {
      var thisObj = this;
      fetch("/ja-jp/upload-contents/web-api/draft-images", {
        body: JSON.stringify({
          imageId: image.imageId
        }),
        headers: {
          "content-type": "application/json",
          "X-CSRF-TOKEN": thisObj.csrfToken
        },
        method: "DELETE"
      })
        .then(response => response.json())
        .then(e => {
          if (e.status == 0) {
            thisObj.images.splice(index, 1);
          }
        });
    },
    moveUpImage: function(image, index) {
      if (index >= 1) {
        this.images.splice(
          index - 1,
          2,
          this.images[index],
          this.images[index - 1]
        );
        this.imageSort();
      }
    },
    moveDownImage: function(image, index) {
      if (index < this.images.length - 1) {
        this.images.splice(
          index,
          2,
          this.images[index + 1],
          this.images[index]
        );
        this.imageSort();
      }
    },
    imageSort: function() {
      fetch("/ja-jp/upload-contents/web-api/draft-images-order", {
        body: JSON.stringify({
          draftId: this.draftId,
          images: this.images
        }),
        headers: {
          "content-type": "application/json",
          "X-CSRF-TOKEN": this.csrfToken
        },
        method: "PUT"
      });
    },
    selectThumbnailImageFile: function(e) {
      var files = e.target.files;
      if (files.length == 0) {
        return;
      }

      const reader = new FileReader();
      reader.onload = event => {
        this.thumbnailImageCropperRotation = 0;
        this.thumbnailImageOriginalFileData = event.target.result;
        this.$nextTick(() => {
          this.$refs.thumbnailImageCropper.relpace(event.target.result);
        });
      };
      reader.readAsDataURL(files[0]);
    },
    selectThumbnailImageCropperReady() {
      const margin = 1;
      const cropAspectRatio = 1 / Math.sqrt(2);

      const containerData = this.$refs.thumbnailImageCropper.getContainerData();
      const imageData = this.$refs.thumbnailImageCropper.getImageData();

      let cropDataWidth = containerData.width - margin * 2;
      let cropDataHeight = cropDataWidth / cropAspectRatio;
      if (cropDataHeight > containerData.height - margin * 2) {
        cropDataHeight = containerData.height - margin * 2;
        cropDataWidth = cropDataHeight * cropAspectRatio;
      }

      let canvasWidth = cropDataWidth;
      let canvasHeight = canvasWidth / imageData.aspectRatio;
      if (canvasHeight > cropDataHeight) {
        this.$refs.thumbnailImageCropper.setCanvasData({
          left: (containerData.width - canvasWidth) / 2,
          top: margin,
          width: canvasWidth
        });
      } else {
        canvasHeight = cropDataHeight;
        canvasWidth = canvasHeight * imageData.aspectRatio;
        this.$refs.thumbnailImageCropper.setCanvasData({
          left: (containerData.width - canvasWidth) / 2,
          top: margin,
          height: canvasHeight
        });
      }

      this.$refs.thumbnailImageCropper.setCropBoxData({
        left: (containerData.width - cropDataWidth) / 2,
        top: (containerData.height - cropDataHeight) / 2,
        width: cropDataWidth,
        height: cropDataHeight
      });
    },
    thumbnailImageCropperZoom: function(zoom) {
      this.$refs.thumbnailImageCropper.relativeZoom(zoom);
    },
    thumbnailImageCropperRotate: function() {
      this.$refs.thumbnailImageCropper.rotateTo(
        this.thumbnailImageCropperRotation
      );
    },
    setThumbnailImage: function() {
      if (!this.thumbnailImageOriginalFileData) {
        return;
      }

      var thisObj = this;
      this.isThumbnailImageUploadProcessing = true;
      new Promise(resolve => {
        if (
          typeof thisObj.$refs.thumbnailImageCropper.getCroppedCanvas()
            .toBlob == "function"
        ) {
          thisObj.$refs.thumbnailImageCropper
            .getCroppedCanvas()
            .toBlob(blob => {
              resolve(blob);
            });
        } else {
          const binStr = atob(
            thisObj.$refs.thumbnailImageCropper
              .getCroppedCanvas()
              .toDataURL()
              .split(",")[1]
          );
          const len = binStr.length;
          const arr = new Uint8Array(len);

          for (let i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
          }

          resolve(new Blob([arr]));
        }
      }).then(blob => {
        fetch("/ja-jp/upload-contents/web-api/draft-thumbnail-image", {
          body: JSON.stringify({
            draftId: thisObj.draftId
          }),
          headers: {
            "content-type": "application/json",
            "X-CSRF-TOKEN": thisObj.csrfToken
          },
          method: "POST"
        })
          .then(response => response.json())
          .then(e => {
            if (e.status == 0) {
              return fetch(e.data.signedUrl, {
                body: blob,
                method: "PUT"
              });
            }
          })
          .then(function() {
            return fetch(
              "/ja-jp/upload-contents/web-api/draft-thumbnail-image-complete",
              {
                body: JSON.stringify({
                  draftId: thisObj.draftId
                }),
                headers: {
                  "content-type": "application/json",
                  "X-CSRF-TOKEN": thisObj.csrfToken
                },
                method: "POST"
              }
            );
          })
          .then(response => response.json())
          .then(function(e) {
            if (e.status == 0) {
              thisObj.thumbnailImageUrl = e.data.imageUrl;
              thisObj.thumbnailImageOriginalFileData = "";
              thisObj.isShowSelectThumbnailImageDialog = false;
              thisObj.isThumbnailImageUploadProcessing = false;
            }
          });
      });
    },
    resetThumbnailImage: function() {
      var thisObj = this;
      fetch("/ja-jp/upload-contents/web-api/draft-thumbnail-image", {
        body: JSON.stringify({
          draftId: thisObj.draftId
        }),
        headers: {
          "content-type": "application/json",
          "X-CSRF-TOKEN": thisObj.csrfToken
        },
        method: "DELETE"
      })
        .then(response => response.json())
        .then(e => {
          if (e.status == 0) {
            thisObj.thumbnailImageUrl = null;
          }
        });
    },
    publish: function() {
      var thisObj = this;
      this.isPublishing = true;
      fetch("/ja-jp/upload-contents/web-api/publish", {
        body: JSON.stringify({
          draftId: thisObj.draftId,
          jwt: thisObj.jwt
        }),
        contentType: "application/json",
        headers: {
          "content-type": "application/json",
          "X-CSRF-TOKEN": thisObj.csrfToken
        },
        method: "POST"
      })
        .then(response => response.json())
        .then(e => {
          if (e.status == 0) {
            location.href = e.data.redirectUrl;
          }
          this.isPublishing = false;
        });
    },
    preview() {
      this.isPreviewLoading = true;
      this.previewTimeProceedSec = 0;

      // プレビュー生成APIを呼び出し、完了後にプレビュー画面を表示する
      const url = "/ja-jp/upload-contents/web-api/draft-preview";
      let requestData = { draftId: this.draftId };
      // TODO: API呼び出しを共通化する (locale, csrfToken)
      fetch(url, {
        body: JSON.stringify(requestData),
        headers: {
          "content-type": "application/json",
          "X-CSRF-TOKEN": this.csrfToken
        },
        method: "POST"
      })
        .then(response => response.json())
        .catch(() => {
          this.isPreviewLoading = false;
        })
        .then(response => {
          if (response.status == 0) {
            const viewerUrl = response.data.viewerUrl;
            window.open(viewerUrl, "_blank");
          } else {
            if (response.code == "INVALID_ID") {
              this.errorMessage = this.lang.error_invalid_id;
            } else if (response.code == "NOT_SET_PAGE_PROGRESSION_DIRECTION") {
              this.errorMessage = this.lang.error_not_set_page_progression_direction;
            } else if (response.code == "NOT_EXISTS_IMAGE") {
              this.errorMessage = this.lang.error_not_exists_images;
            } else if (response.code == "IMAGE_UPLOAD_INCOMPLETE") {
              this.errorMessage = this.lang.error_exists_incomplete_images;
            } else {
              this.errorMessage = this.lang.error_failed;
            }
          }
          this.isPreviewLoading = false;
        });
    }
  }
};
</script>
